import React, { useContext } from 'react';
import { IconSave01, IconTrash03, IconXClose } from '@pentabd/icons';
import Text from '../../text/Text';
import Dropdown from '../../dropdown/Dropdown';
import { ShowExtendedDeleteViewProps } from './types';
import { TableContext } from '../Table/provider/Provider';

interface Props {
  onClickDeleteExtensionClose: () => void;
  showExtendedDeleteView: ShowExtendedDeleteViewProps;
}

function DeleteExtension({
  onClickDeleteExtensionClose,
  showExtendedDeleteView,
}: Props) {
  const { selectedIdsData } = useContext(TableContext);
  return (
    <div className="d-flex justify-content-between align-items-center bg-primary px-12 py-8 mx-12 my-10 gap-12 rounded-6 flex-wrap">
      <div className="d-flex gap-8 align-items-center">
        <div
          onClick={onClickDeleteExtensionClose}
          className="d-flex align-items-center pointer"
        >
          <IconXClose size="20" fill="white" />
        </div>
        <Text color="white" size="sm" weight="medium">
          {selectedIdsData.selectedIds.length} Selected
        </Text>
      </div>
      <div className="d-flex align-items-center flex-wrap gap-10">
        {showExtendedDeleteView?.showExtendedDeleteComponent}

        {showExtendedDeleteView?.save?.active ? (
          <div
            className="pointer"
            onClick={() =>
              showExtendedDeleteView?.save?.onSave(selectedIdsData.selectedIds)
            }
          >
            <IconSave01 size="20" fill="white" />
          </div>
        ) : null}

        {showExtendedDeleteView?.remove?.active ? (
          <div
            className="pointer"
            onClick={() =>
              showExtendedDeleteView?.remove?.onRemove(
                selectedIdsData.selectedIds,
              )
            }
          >
            <IconTrash03 size="20" fill="white" />
          </div>
        ) : null}

        {Array.isArray(showExtendedDeleteView?.showExtendedDeleteDropdown) ? (
          <Dropdown
            buttonType="icon"
            iconStyle={{ fill: 'white' }}
            listItem={showExtendedDeleteView?.showExtendedDeleteDropdown}
            portal
          />
        ) : null}
      </div>
    </div>
  );
}

export default DeleteExtension;
